<template>
  <!-- 派送费列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">

        <el-button plain
                   class="glo_btnItems glo_bgcMainColor"
                   @click="onClickEvent('1')"

        >新建</el-button>
        <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onClickEvent('2')"
        >修改</el-button
        >
        <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onDelLineChannel"
        >删除</el-button
        >
        <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onClickEvent('3')"
        >复制新增</el-button
        >
        <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onStartLineChannel"
        >启用</el-button
        >
        <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onStopLineChannel"
        >禁用</el-button
        >

      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field === 'aaaaaaaaaa' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel">
                {{ scope.row.aaaaaaaaaa }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>

      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!--        自定义表头           -->
    <!-- <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
      ></sorttable> -->

    <!-- 导出插件 -->
    <!-- <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent> -->




  </div>
</template>
  <script>
import tableList from "@/pages/DynamicList/tableList.js";
//   import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtnsDT.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/DialogDT.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import utils from "@/assets/js/tool";
//   import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import { Api } from "@/assets/js/api";

export default {
  mixins: [tableList],
  inject: ["reload"],
  components: {
    paging,
    queryBtns,
    queryCondition,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "派送费列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd===等待下载完成,bdd===不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "DynamicListFeeDeveliryList", //  页面标识
      reportFiledsNumber: "channel_delivery_fee_list", // 动态 条件、表头
      currentItemArr: [],
      dataList: [],
    };
  },
  mounted() {
    this.queryBtn_ok();
  },
  watch: {},
  created() {
  },
  methods: {
    // 表格选择事件
    handleSelectionChange(e) {
      this.currentItemArr = e || [];
    },

    // 不能输入负数F
    minNum(val) {
      return val < 0 ? 0 : val;
    },

    async onClickEvent(status) {
      if (status === "1") {
        let obj = {
          status: "create",
          cache: false,
        };
        await this.$router.push({
          path: "/pages/v4/delivery/fee/deliveryFeeCreation",
          query: obj,
        });
      } else if (status === "2") {
        if (this.currentItemArr.length === 1) {
          let obj = {
            status: "modify",
            id: this.currentItemArr[0]["channelId"],
          };
          await this.$router.push({ path: "/pages/v4/delivery/fee/deliveryFeeEdit", query: obj });
        } else {
          ElMessage({
            message: "请选择1条表格数据",
            type: "warning",
          });
        }
      } else if (status === "3") {
        if (this.currentItemArr.length === 1) {
          let obj = {
            status: "copy",
            id: this.currentItemArr[0]["channelId"],
          };
          await this.$router.push({
            path: "/pages/v4/delivery/fee/deliveryFeeCreation",
            query: obj,
          });
        } else {
          ElMessage({
            message: "请选择1条表格数据",
            type: "warning",
          });
        }
      }
    },

    async onDelLineChannel(){
      if (this.currentItemArr.length >= 1) {
        ElMessageBox.confirm("确认把所选数据删除？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          const idList = this.currentItemArr.map((item) => {
            return item.channelId;
          });
          let params = {
            channelIds: idList,
          };
          await Api.delLineChannel(params).then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (utils.jyCheckObjectType(data) === "Object") {
                ElMessage({
                  message: data.message,
                  type: data.status,
                });
                this.getData()
              }
            }
          });
        });
      } else {
        ElMessage({
          message: "请选择表格数据",
          type: "warning",
        });
      }
    },
    async onStartLineChannel(){
      if (this.currentItemArr.length >= 1) {
        ElMessageBox.confirm("确认把所选数据启用？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          const idList = this.currentItemArr.map((item) => {
            return item.channelId;
          });
          let params = {
            channelIds: idList,
          };
          await Api.startLineChannel(params).then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (utils.jyCheckObjectType(data) === "Object") {
                ElMessage({
                  message: data.message,
                  type: data.status,
                });
                this.getData()
              }
            }
          });
        });
      } else {
        ElMessage({
          message: "请选择表格数据",
          type: "warning",
        });
      }
    },
    async onStopLineChannel(){
      if (this.currentItemArr.length >= 1) {
        ElMessageBox.confirm("确认把所选数据禁用？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          const idList = this.currentItemArr.map((item) => {
            return item.channelId;
          });
          let params = {
            channelIds: idList,
          };
          await Api.stopLineChannel(params).then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (utils.jyCheckObjectType(data) === "Object") {
                ElMessage({
                  message: data.message,
                  type: data.status,
                });
                this.getData()
              }
            }
          });
        });
      } else {
        ElMessage({
          message: "请选择表格数据",
          type: "warning",
        });
      }
    },


  }

};
</script>
  <style scoped lang="scss">
::v-deep .el-date-editor.el-input {
  width: auto !important;
}


</style>
  